enum Device {
    ALL = '',
    SMALL = 'sm:',
    MEDIUM = 'md:',
    LARGE = 'lg:',
    XL = 'xl:',
    XXL = '2xl:'
}
export default Device;